<template>
  <div>
    {{ lesson ? lesson.title : '' }}
    <div
      ref="richText"
      :class="['rich-text-content', useMargin ? 'rich-text-content-margin' : '', center ? 'center':'']"
      v-html="htmlString"
    ></div>
    <div
      ref="richTextOverlay"
      v-if="this.useOverlay"
      :class="['rich-text-overlay', `rich-text-${this.$mq}`]"
      @click.stop="closeOverlay"
    >
      <span ref="richTextCloseButton" class="rich-text-close-button" @click.stop="closeOverlay"
        >X</span
      >
      <img ref="richTextOverlayImage" class="rich-text-overlay-img" />
    </div>
  </div>
</template>

<script>
import { richTextToHtml } from '@/services/contentfulRichText'

export default {
  props: {
    document: Object,
    useOverlay: {
      type: Boolean,
      default: true
    },
    useMargin: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    htmlString() {
      return richTextToHtml(this.document)
    }
  },
  methods: {
    closeOverlay() {
      const overlay = this.$refs.richTextOverlay
      const overlayImg = this.$refs.richTextOverlayImage

      overlayImg.removeAttribute('src')
      overlay.classList.remove('displayOverlay')
      overlay.style.top = '0'
    },
    bindListeners() {
      /**
       * @type {HTMLElement[]}
       */
      const lessonTags = this.$refs.richText.querySelectorAll('[data-content-type="lesson"]')

      lessonTags.forEach(tag => {
        const contentId = tag.getAttribute('data-content-id')

        tag.onclick = () => {
          this.navigateToLesson(contentId)
        }
      })

      if (this.useOverlay) {
        const overlay = this.$refs.richTextOverlay
        const overlayImg = this.$refs.richTextOverlayImage
        const lessonImages = this.$refs.richText.querySelectorAll('.contentful-image')

        lessonImages.forEach(image => {
          const imgSrc = image.getAttribute('src')
          image.onclick = () => {
            const posY = window.pageYOffset
            overlayImg.src = imgSrc
            overlay.classList.add('displayOverlay')
            overlay.style.top = `${posY}px`
          }
        })
      }
    },
    navigateToLesson(lessonId) {
      const lessonStep =
        Object.values(this.$store.state.lesson.lessonStep.byId).find(lessonStep =>
          lessonStep.lessons.includes(lessonId)
        ) || this.$store.getters.currentLessonStep

      const theme =
        Object.values(this.$store.state.lesson.theme.byId).find(theme =>
          theme.lessonSteps.includes(lessonStep.id)
        ) || this.$store.getters.currentTheme

      this.$router.push({
        name: 'lesson',
        params: {
          lessonId,
          lessonStepId: lessonStep.id,
          themeId: theme.id
        }
      })
    }
  },
  watch: {
    htmlString() {
      this.bindListeners()
    }
  },
  mounted() {
    this.bindListeners()
  },
  updated() {
    this.$nextTick(function() {
      this.bindListeners()
    })
  }
}
</script>

<style lang="scss">
/* It needs to not be scoped to propagate styles */
@import '@/assets/styles/_variables.scss';

.contentful-image-container {
  width: 100%;
  text-align: center;

  .contentful-image {
    max-width: 100%;
  }
}

.rich-text-content {
  text-align: left;
}

.rich-text-content-margin {
  padding-left: 50px;
  padding-right: 50px;
}

.center {
  display:flex;
  flex-direction: column;
  align-items: center;
}

/* Embedded entries */
.contentful-entry-container {
  border-radius: 24px;
  box-shadow: 2px 2px 8px $dark-50;
  padding: 8px;
  box-sizing: border-box;
  cursor: pointer;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;

  .contentful-entry-image {
    display: inline-block;
    border-radius: 20px;
    height: 100%;
    max-width: 35%;
  }

  .contentful-entry-title {
    display: flex;
    font-weight: bold;
    font-size: 26px;
    color: $primary;
    flex-grow: 1;
    justify-content: center;
  }
}

.rich-text-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  z-index: 9000;
  display: none;
  padding-bottom: 80px;

  &.displayOverlay {
    display: block;
  }

  &.rich-text-desktop {
    width: 75%;
    margin-left: 12.5%;
    margin-right: 12.5%;
  }

  .rich-text-overlay-img {
    width: 100%;
    height: auto;
    position: relative;
    top: 20px;
  }

  .rich-text-close-button {
    color: #d10a4a;
    padding: 5px;
    font-size: 20px;
    background-color: #ede6ca;
    border-radius: 50%;
    position: relative;
    width: 25px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
    top: 10px;
    right: 10px;
    float: right;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
